export default __webpack_public_path__ + "6e283073244023878cac912be21d2198.png";